<template>
    <div class="py-4">
        <div class="flex flex-wrap gap-3 mb-4 justify-between  items-center">

            <div class="flex gap-2 items-end">
        <div>
          <label class="block text-xs text-gray-600 dark:text-gray-400 mb-1">Başlangıç Tarihi</label>
          <input type="date" v-model="startDate"
            class="h-10 px-3 rounded-lg border border-light-border dark:border-gray-600 bg-primary-bg dark:bg-gray-800 text-sm text-primary-text dark:text-gray-100 focus:border-indigo-500 focus:ring focus:ring-blue-100/50" />
        </div>
        <div>
          <label class="block text-xs text-gray-600 dark:text-gray-400 mb-1">Bitiş Tarihi</label>
          <input type="date" v-model="endDate"
            class="h-10 px-3 rounded-lg border border-light-border dark:border-gray-600 bg-primary-bg dark:bg-gray-800 text-sm text-primary-text dark:text-gray-100 focus:border-indigo-500 focus:ring focus:ring-blue-100/50" />
        </div>
        <button @click="applyFilter"
          class="bg-primary-button hover:bg-primary-button-hover text-white px-4 py-2 rounded text-sm">
          Filtrele
        </button>

    </div>
        </div>

        <div
            class="overflow-hidden rounded-md border border-light-border dark:border-dark-border bg-primary-bg dark:bg-primary-dark-bg pb-3 shadow-md">
            <div class="w-full overflow-x-auto">
                <table class="min-w-full text-left text-sm text-secondary-text dark:text-gray-300">
                    <thead class="bg-gray-100 dark:bg-gray-800 font-medium">
                        <tr>
                            <th class="px-3 md:px-6 py-2 md:py-4">Tarih</th>
                            <th class="px-3 md:px-6 py-2 md:py-4">İşlem</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="log in logs" :key="log.id"
                            class="border-b transition hover:light-hover dark:hover:dark-hover">
                            <td class="px-3 md:px-6 py-2 md:py-4 font-medium text-primary-text dark:text-gray-100">
                                {{ formatDate(log.created) }}
                            </td>
                            <td class="px-3 md:px-6 py-2 md:py-4 font-medium text-primary-text dark:text-gray-100">
                                {{ log.action_type }} - {{ log.action_details }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <AppPagination 
          :currentPage="currentPage" 
          :totalPages="totalPages" 
          :pageSize="pageSize"
          :totalItems="totalCount"
          @prev-page="changePage(currentPage - 1)"
          @next-page="changePage(currentPage + 1)" 
          @go-to-page="changePage"
          @update:pageSize="handlePageSizeChange"
        />

        </div>

    
    </div>
</template>

<script>
import { getApi } from "@/services/api";
import AppPagination from "@/components/AppPagination.vue";
import { DateTime } from "luxon"

export default {
    name: "LogsPage",
    components: {
        AppPagination,
    },
    data() {
        return {
            logs: [],
            currentPage: 1,
            pageSize: 50,
            totalCount: 0,
            startDate: DateTime.now().minus({ weeks: 1 }).toFormat("yyyy-MM-dd"),
            endDate: DateTime.now().plus({ days: 1 }).toFormat("yyyy-MM-dd"),
        };
    },
    computed: {
        totalPages() {
            return Math.ceil(this.totalCount / this.pageSize);
        },
    },

    methods: {
        handlePageSizeChange(newPageSize) {
            this.pageSize = newPageSize;
            this.currentPage = 1;
            this.fetchLogs();
        },

        changePage(page) {
            this.currentPage = page;
            this.fetchLogs();
        },
        applyFilter() {
            this.currentPage = 1;
            this.fetchLogs();
        },

        async fetchLogs() {
            const take = this.pageSize;
            const skip = (this.currentPage - 1) * this.pageSize;

            const start_date = this.startDate
                ? DateTime.fromISO(this.startDate).startOf("day").toFormat("yyyy-MM-dd'T'HH:mm:ss")
                : "";

            const end_date = this.endDate
                ? DateTime.fromISO(this.endDate).endOf("day").toFormat("yyyy-MM-dd'T'HH:mm:ss")
                : "";

            try {
                const response = await getApi(
                    `/logs/?take=${take}&skip=${skip}&start_date=${start_date}&end_date=${end_date}`
                );

                if (!response.logs) {
                    this.logs = [];
                    this.totalCount = 0;
                    return
                }

                this.logs = response.logs;
                this.totalCount = response.total_result;
            } catch (error) {
                this.logs = [];
                this.totalCount = 0;
            }
        },

        formatDate(dateStr) {
            if (!dateStr) {
                return "";
            }

            const date = new Date(dateStr);
            if (isNaN(date.getTime())) {
                return "";
            }

            return date.toLocaleString("tr-TR");
        },
    },
    mounted() {
        this.fetchLogs();
    },
    
    watch: {
        currentPage() {
            this.fetchLogs();
        },
        pageSize() {
            this.currentPage = 1;
            this.fetchLogs();
        }
    },
};
</script>
